// eslint-disable-next-line max-classes-per-file
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Directive,
} from '@angular/core';
import { Token } from '@cigna/resource-content/contracts';
import { Renderer } from './renderer.interface';

@Directive()
export abstract class UIComponentRendererDirective implements Renderer {
  @Input() token: Token;
}

@Component({
  selector: 'cigna-content-button',
  template: `
    <button [cignaButton]="token[2]" [attr.class]="token[3]">
      <ng-template [cignaContentRenderer]="token[1]" let-text>
        {{ text }}
      </ng-template>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonRendererComponent extends UIComponentRendererDirective {}

@Component({
  selector: 'cigna-content-icon',
  template: `
    <cigna-icon [type]="token[2]" [attr.class]="token[3]">
      <ng-template [cignaContentRenderer]="token[1]" let-text>
        {{ text }}
      </ng-template>
    </cigna-icon>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconRendererComponent extends UIComponentRendererDirective {}
